import type { DmAddressForm, DmFormErrors } from './dmForms.ts';
import { DmTextField } from './DmTextField';

interface DmAddressFieldsProps {
    prefix: 'shipping' | 'billing';
    value: DmAddressForm;
    onChange: (next: DmAddressForm) => void;
    errors: DmFormErrors;
    regionRequired: boolean;
}

export function DmAddressFields({
    prefix,
    value,
    onChange,
    errors,
    regionRequired
}: DmAddressFieldsProps) {
    const field = (key: keyof DmAddressForm) => ({
        value: value[key],
        onChange: (next: string) => onChange({ ...value, [key]: next }),
        error: errors[`${prefix}.${key}`]
    });

    return (
        <div className="grid grid-cols-2 gap-3">
            <div className="col-span-2">
                <DmTextField label="Practice name" {...field('name')} />
            </div>
            <div className="col-span-2">
                <DmTextField
                    label="Email"
                    type="email"
                    placeholder="office@practice.com"
                    {...field('email')}
                />
            </div>
            <div className="col-span-2">
                <DmTextField label="Street address" {...field('address')} />
            </div>
            <DmTextField label="City" {...field('city')} />
            <DmTextField label="ZIP" {...field('zipCode')} />
            <DmTextField
                label={regionRequired ? 'State / province' : 'State / province (optional)'}
                placeholder="TX"
                {...field('regionCode')}
            />
        </div>
    );
}
